import { getLocalisedName } from "./i18n";

export interface AdminAreaChainItem {
  id: number;
  name: string;
  name_translations?: Record<string, string>;
  type: string;
  type_translations?: Record<string, string>;
  admin_level: number;
}

export const formatAdminAreaChain = (chain?: AdminAreaChainItem[] | null): string =>
  (chain ?? [])
    .map(area => getLocalisedName(area))
    .filter(Boolean)
    .join(", ");
